module.exports = "https://tutorchat.chegg.com/static/media/ic-select-arrows.aef1eac2.svg";